import { useEffect, type ReactNode } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { useTranslation } from 'react-i18next';
import { themeComponents, themeTokens, getAntdLocale } from '@/shared/config/theme';

export function AntdProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();

  // Global dayjs locale — antd's own components read locale from ConfigProvider below, but any
  // direct `dayjs(...).format(...)` call (e.g. CheckoutForm's delivery-date picker) uses dayjs's
  // own locale singleton, which stays 'en' unless set here.
  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  return (
    <ConfigProvider
      theme={{ token: themeTokens, components: themeComponents, cssVar: true, hashed: false }}
      locale={getAntdLocale(i18n.language)}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
